if(typeof AI == "undefined") {
    AI = {};
}

(function (AI) {
    'use strict';

    var mapBox = function() {
        this.mapBox = {};
    };

    mapBox.prototype = {

        map: false,

        // Holds properties
        properties: [],
        infoWindow: false,

        // Map Marker
        icon: APP.map_marker,

        // Holds an array of markers to display on the map
        markers: [],

        lat: false,
        lng: false,
        radius: false,

        // Initiates google maps view
        init: function(token, properties, id, includeClusterMarkers) {

            var url_string = window.location.href;

            var lat = this.gup('lat', url_string);
            var lng = this.gup('lng', url_string);
            var radius = this.gup('radius', url_string);

            if (lat && lng && radius) {
                this.lat = lat;
                this.lng = lng;
                this.radius = radius;
            } else {
                this.lat = AI.lat;
                this.lng = AI.lng;
            }

            // Take reference of the properties
            this.properties = properties;

            mapboxgl.accessToken = token;
            this.map = new mapboxgl.Map({
                container: 'map',
                style: 'mapbox://styles/darrylfriend/cjlgqedij1gxx2rrottx2yc9z',
                center: {lat: this.lat, lng: this.lng},
                zoom: 8
            });

            this.map.scrollZoom.disable();
            this.map.addControl(new mapboxgl.NavigationControl(), 'bottom-right');

            // Generate markers
            if (typeof this.properties !== 'undefined' && this.properties.length > 0) {
                this.generateMarkers(true);
            } else {
                var bounds = new mapboxgl.LngLatBounds();
                this.drawSearchArea(bounds);
            }
        },

        gup: function(name, url) {
            if (!url) url = location.href;
            name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
            var regexS = "[\\?&]"+name+"=([^&#]*)";
            var regex = new RegExp( regexS );
            var results = regex.exec( url );
            return results == null ? null : results[1];
        },

        // Generate the markers to display
        generateMarkers: function() {

            var property, marker;
            var self = this;

            // Lat Long Bounds
            var bounds = new mapboxgl.LngLatBounds();
            var lnglat;

            var markerLayer = {
                "id": "points",
                "type": "symbol",
                "source": {
                    "type": "geojson",
                    "data": {
                        "type": "FeatureCollection",
                        "features": []
                    }
                },
                "layout": {
                    'icon-image': 'custom_marker',
                    'icon-allow-overlap': true,
                    'text-allow-overlap': true
                }
            };

            // Loop over properties generating markers
            var properties_count = this.properties.length;
            for (var i = 0; i < properties_count; i++) {

                property = this.properties[i];

                // Don't show properties that do not have lat / long set correctly!
                if (property.lat === 0 && property.lng === 0) {
                    continue;
                }

                markerLayer.source.data.features.push({
                    "type": "Feature",
                    "geometry": {
                        "type": "Point",
                        "coordinates": [property.lng, property.lat]
                    },
                    "properties": {
                        "description": "",
                        'disposal': property
                    }
                });

                lnglat = new mapboxgl.LngLat(property.lng, property.lat);
                bounds.extend(lnglat);
            }

            this.map.loadImage(this.icon, function(error, image) {
                if (error) console.log(error);
                self.map.addImage('custom_marker', image);
            });

            this.setMapPosition(markerLayer, bounds);

            // Add marker data as a new GeoJSON source.
            this.map.on('load', function() {

                self.map.addLayer(markerLayer);
                self.map.on('click', 'points', function (e) {

                    var data = JSON.parse(e.features[0].properties.disposal);
                    var coordinates = e.features[0].geometry.coordinates.slice();

                    // Ensure that if the map is zoomed out such that multiple
                    // copies of the feature are visible, the popup appears
                    // over the copy being pointed to.
                    while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                        coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                    }
                    new mapboxgl.Popup().setLngLat(coordinates).setHTML(self.setPopupContent(data)).addTo(self.map);
                });
            });
        },

        setMapPosition: function(markerLayer, bounds) {

            this.drawSearchArea(bounds);

            if (markerLayer.source.data.features.length == 1) {
                // Center map on marker
                this.map.setCenter(new mapboxgl.LngLat(this.properties[0].lng, this.properties[0].lat));
                this.map.setZoom(15);
            } else {
                this.map.fitBounds(bounds, {duration: 0, padding: 40});
            }
        },

        drawSearchArea: function(bounds) {

            this.map.setCenter(new mapboxgl.LngLat(this.lng, this.lat));
            var self = this;

            if (!AI.searchLat && !AI.searchLng && !AI.searchRadius) {
                return;
            }

            if (!bounds) {
                return;
            }

            var circle = self.createGeoJSONCircle([AI.searchLng, AI.searchLat], AI.searchRadius, 64, bounds);

            this.map.on('load', function() {
                self.map.addSource("polygon", circle);
                self.map.addLayer({
                    "id": "polygon",
                    "type": "line",
                    "source": "polygon",
                    "layout": {},
                    "paint": {
                        "line-color": "#000",
                        "line-dasharray": [5,5]
                    }
                });
                self.map.fitBounds(bounds, {duration: 0, padding: 40});
            });
        },

        createGeoJSONCircle: function(center, radiusInMiles, points, bounds) {
            if(!points) points = 64;

            var coords = {
                latitude: parseFloat(center[1]),
                longitude: parseFloat(center[0])
            };

            // convertRadius to KM
            var km = (radiusInMiles * 1.609344);

            var ret = [];
            var distanceX = km/(111.320*Math.cos(coords.latitude*Math.PI/180));
            var distanceY = km/110.574;

            var theta, x, y;
            for(var i=0; i<points; i++) {
                theta = (i/points)*(2*Math.PI);
                x = distanceX*Math.cos(theta);
                y = distanceY*Math.sin(theta);

                ret.push([coords.longitude+x, coords.latitude+y]);
                bounds.extend(new mapboxgl.LngLat(coords.longitude+x, coords.latitude+y));
            }
            ret.push(ret[0]);

            return {
                "type": "geojson",
                "data": {
                    "type": "FeatureCollection",
                    "features": [{
                        "type": "Feature",
                        "geometry": {
                            "type": "Polygon",
                            "coordinates": [ret]
                        }
                    }]
                }
            };
        },

        setPopupContent: function(property) {

            var image = '';

            if (Array.isArray(property.images) && property.images.length > 0) {
                image = '';
                if (property.images[0].image_sources != undefined) { // AI
                    image = property.images[0].image_sources.front_back_large;
                } else { // AS
                    image = property.images[0].url;
                }
            } else if (!Array.isArray(property.images) && property.images instanceof Object) {
                image = property.images.front_back_large;
            } else if (image == '' && property.default_images != undefined) {
                image = property.default_images.front_back_large;
            } else if (property.images != '') {
                image = property.images;
            }

            if (image) {
                image = '<img src="'+image+'" alt="Image Coming Soon" width="240" height="160"></a>';
            }

            var name = property.name;
            var town = property.town;
            var url = property.url ? property.url : APP.properties_url + '/' + property.meta_id;

            return '<div id="google-popup">'+
                    '<a class="featured-image" href="'+url+'">' + image + '</a>' +
                    '<div class="google-popup-content">' +
                    '<span class="town">'+ town +'</span><br>' +
                    '<span class="name">'+ name +'</span><br>' +
                    '<a target="_blank" href="'+url+'" class="details">More details</a>' +
                '</div>';
        }
    };

    AI.mapBox = new mapBox();

})(AI);


// WEBPACK FOOTER //
// ./resources/assets/js/ai/map-box.js